import Vue from "vue";
import * as rt from "../../../routes/routes";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router";

export const actions = {
  newCfs({ commit }) {
    let cfsDetails = {
      cfs_name: $(".cfs_name").val()
    };
    $(".creatingCfs").hide();
    $(".creatingCfsLoader").show();
    baseurl.post(rt.newCfs, cfsDetails).then(res => {
      $(".creatingCfs").show();
      $(".creatingCfsLoader").hide();

      if (res.data.code === 200) {
        $(".form-control").val("");
        commit("STORE_CFS", res.data.cfs);
        window.$("#new-cfs").modal("hide");
        suc.cfsCreateSuccess();
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.CfsExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingCfs();
      } else if (res.data.code === 405) {
        $(".form-control").val("");
        ers.noPermissionToCreate(), window.$("#new-cfs").modal("hide");
      } else if (res.data.code === 506) {
        window.$("#new-cfs").modal("hide");
        ses.sessionComplete();
      }
    });
  },

  loadCfs({ commit }) {
    baseurl.get(rt.loadCfs).then(res => {
      $(".cfsLoader").hide();
      if (res.data.code === 200) {
        commit("STORE_CFS", res.data.cfs);
      } else if (res.data.code === 404) {
        ers.errorLoadingCfs();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        commit("STORE_CFS", []);
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  updateCfs({ commit }) {
    let cfsDetail = {
      id: $(".id").val(),
      cfs_name: $(".cfs_name").val()
    };
    $(".updatingCfs").hide();
    $(".updatingCfsLoader").show();
    baseurl.post(rt.updateCfs, cfsDetail).then(res => {
      $(".updatingCfs").show();
      $(".updatingCfsLoader").hide();

      if (res.data.code === 200) {
        window.$("#update-cfs").modal("hide");
        suc.cfsUpdateSuccess();
        commit("STORE_CFS", res.data.cfs);
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 404) {
        ers.errorUpdatingCfs();
      } else if (res.data.code === 405) {
        window.$("#update-cfs").modal("hide");
        ers.noPermissionToUpdate();
      } else if (res.data.code === 506) {
        window.$("#update-cfs").modal("hide");
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/cfs/actions.js